import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import useSeo, { CANONICAL_BASE } from "@/lib/useSeo";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => setSettings({}));
  }, []);

  const seo = settings?.seo || {};
  useSeo({
    title: seo.title || "ONUSA — Premium Contemporary Streetwear",
    description: seo.description,
    canonical: CANONICAL_BASE + window.location.pathname,
    image: seo.og_image,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "ONUSA",
      url: CANONICAL_BASE,
      slogan: "Discipline creates freedom",
    },
  });

  return <SettingsContext.Provider value={{ settings: settings || {} }}>{children}</SettingsContext.Provider>;
}
